<template>
  <b-modal
    id="how-modal"
    v-model="show" 
    ok-only 
    centered 
    size="lg" 
    footer-class="border-top d-none d-sm-block"
    body-class="px-0"
    header-class="d-none d-sm-block"
    :ok-title="hebrew ? 'סגור' : 'Close'"
    ok-variant="secondary"
    >
    <template slot="modal-header">{{hebrew ? 'איך זה עובד' : 'How it works'}}</template>
    <div class="mobile-modal-top bg-secondary position-fixed w-100 d-block d-sm-none">
      <div class="row">
        <div class="col-8">
          <h3>{{hebrew ? 'איך זה עובד' : 'How it works'}}</h3>
        </div>
        <div @click="show=false" class="close-icon col-4" :class="{'text-left': hebrew, 'text-right': !hebrew}">
          <i class="fas fa-times"></i>
        </div>
      </div>
    </div>    
    <div class="how-to-text px-3" v-if="hebrew">
      <div v-if="mobile">
        <p>חרוזית - כלי למציאת חרוזים, מצלול, אליטרציה ומילים על בסיס תבניות ניקוד.</p>
        <p>תוצאות החיפוש מסווגות למספר קטגוריות. לדוגמה: מילים נפוצות, מילים מהתנ״ך, מילים ללא סיומת ועוד.</p>
        <p>להעתקת מילה, לחצו עליה.</p>
        <h3>חיפוש מתקדם</h3>
        <p>כדי לדייק את תוצאות החיפוש, לחצו על ״חיפוש מתקדם״ שנמצא מתחת לתיבת החיפוש.</p>
        <h3>שדה סמנטי</h3>
        <p>את תוצאות החיפוש אפשר לצמצם למכנה משותף מסוים, על ידי בחירת מילים או נושאים קשורים, בתיבת הטקסט של השדה הסמנטי. לדוגמה: כדי לקבל מילים שמתחרזות עם "מַתָּנָה" וקשורות למועדים, הזינו את המילה "חַג" בתיבת הטקסט של השדה הסמנטי וקבלו הַגָּדָה, צַהֲלָה ועוד.</p>
        <h3>רמת דיוק</h3>
        <p>ברירת המחדל כוללת בתוצאות גם מילים שאינן זהות בהברה האחרונה כולה, אלא רק בתנועה האחרונה (ובעיצור סופי, אם יש). דוגמאות: שׁוֹר - חֲמוֹר ; מִשְׁפָּחָה - אַבְחָנָה.</p>
        <p>כדי להציג רק מילים שזהות בהברה האחרונה באופן מלא, הסירו את הסימן של ״שור וחמור״ ותקבלו מילים המתחרזות באופן הבא: שׁוֹר - מִישׁוֹר;  מִשְׁפָּחָה - צְוָחָה.</p>
        <h3>הטעמה</h3>
        <p>ברירת המחדל מתאימה את התוצאות להטעמה (מלעיל / מלרע) של מילת החיפוש. אפשר להגדיר הטעמה של מלעיל בלבד, מלרע בלבד, או הכול.</p>
        <p>כדי להציג חרוזים בעלי הטעמה מלעילית המתחרזים עם המילה ״בית״, סמנו את האפשרות של ״מלעיל״, וקבלו את החרוזים הבאים: כַּזַּיִת, יְרוּשַׁלְמִית, מֵכָנִית, הוּמָנִית.</p>
      </div>
      <div v-else class="pl-3">
        <p>כלי החרוזית נועד לאפשר חיפוש מתקדם של חרוזים, מצלול אליטרציה ותבנית מילה על בסיס מילת חיפוש. את תוצאות החיפוש שהכלי יחזיר אפשר לסנן באמצעות הזנת מילים משדה סמנטי רצוי ומאפיינים דקדוקיים נוספים.</p>
        <p>לאחר הזנת מילת החיפוש יוחזרו תוצאות המסווגות למספר קטגוריות. לתצוגה המלאה של כל קטגוריה לחצו על הקישור ״הצג עוד״ שנמצא בתחתית הטבלה של הקטגוריה הנבחרת.</p>
        <p>כדי לחזור לסקירה הכללית של התוצאות, לחצו על ״חזרה לסקירה כללית״ שממוקם מעל לתיבת החיפוש.</p>
        <p>חרוזים - מילים שמסתיימות בצורה דומה</p>
        <p>מצלול - מילים שהן בעלות אותם עיצורים באופן גמיש - בין בהתחלה, בין באמצע, בין בסוף</p>
        <p>אלטרציה - מילים שפותחות בצורה דומה</p>
        <p>תבנית מילה - מילים בעלות תבנית מילה זהה</p>
        <h3>רמת דיוק</h3>
        <p>חרוזי ״שור וחמור״: ברירת המחדל כוללת בתוצאות גם מילים שאינן זהות בהברה האחרונה כולה (בעיצור ובתנועה), אלא רק בתנועה האחרונה (ובעיצור סופי, אם המילה מסתיימת בעיצור). דוגמות: שׁוֹר - חֲמוֹר; מִשְׁפָּחָה - אַבְחָנָה.</p>
        <p>כדי להציג רק מילים שזהות בהברה האחרונה באופן מלא, הסירו את הסימן של ״שור וחמור״ ותקבלו מילים המתחרזות באופן הזה: שׁוֹר - מִישׁוֹר; מִשְׁפָּחָה - צְוָחָה.</p>
        <p>מילים בעלות דמיון פונטי: אם אפשרות זו מופעלת, התוצאות יכללו מילים שמתחרזות עם עיצורים שנהגים בצורה זהה לעיצורים של מילת הקלט (ב/ו, ט/ת, כ/ח, כ/ק, ס/ש), וכן מילים שמתחרזות עם תנועות זהות כמעט בהגייתן (פתח/קמץ, צירה/סגול). למשל, למילה 'תַּכְסִיסֵי' תובא בין התוצאות 'לְהִנָּשֵׂא', וגם 'תִּתְכַּסֶּה'.</p>
        <p>לעומת זאת, אם אפשרות זו מכובה, התוצאות יכללו רק מילים שמתחרזות עם אותם העיצורים והתנועות של מילת הקלט. כך, למילה 'תַּכְסִיסֵי', יובאו רק מילים כגון 'רְסִיסֵי' או 'מַכְנִיסֵי'.</p>
        <h3>הטעמה</h3>
        <p>ברירת המחדל מתאימה את התוצאות להטעמה (מלעיל או מלרע) של מילת החיפוש. אפשר להגדיר הטעמה מלעילית בלבד, מלרעית בלבד או הכול.</p>
        <p>כדי להציג חרוזים בעלי הטעמה מלעילית המתחרזים עם המילה ״בית״, סמנו את האפשרות של ״מלעיל״ וקבלו את החרוזים הבאים: כַּזַּיִת, יְרוּשַׁלְמִית, מֵכָנִית, הוּמָנִית.</p>
        <h3>שדה סמנטי</h3>
        <p>הזנת מילה או מילים משדה סמנטי רצוי תצמצם את התוצאות לכאלה בעלות משמעות קרובה.</p>
        <h3>הגדרות נוספות</h3>
        <p>ההגדרות הנוספות מתייחסות למאפיינים דקדוקיים: חלקי דיבור, מין, גוף, מספר, סמיכות, זמן, סיומת.</p>
        <h3>הגדרות מתקדמות</h3>
        <p>ההגדרות המתקדמות מאפשרות לצמצם את התוצאות באמצעות התאמת הפרמטרים הייחודיים שמתייחסים לחרוזים, לאליטרציה ולמצלול.</p>
        <h3>שמות פרטיים</h3>
        <p>כדי לכלול שמות פרטיים בתוצאות, יש לסמן את האפשרות ״כלול שמות פרטיים״, שנמצאת תחת ״הגדרות מתקדמות״.</p>
        <h3>רשימת מילים</h3>
        <p>רשימת המילים מאפשרת לכם ליצור רשימה אישית משלכם תוך כדי סריקת התוצאות. במעבר עכבר על מילה מסוימת יופיע כוכב. בלחיצה על הכוכב, המילה תתווסף לרשימת המילים. כדי להסיר את המילה מהרשימה, לחצו על הכוכב הצהוב שהתווסף לצד המילה.</p>
        <p>בצד שמאל של המסך מופיעה הכרטיסייה של רשימת המילים. בלחיצה על הכרטיסייה תוכלו לצפות ברשימת המילים המלאה.</p>
        <p>בכרטיסייה של רשימת המילים, ישנו סרגל כלים שכולל את הפונקציות הבאות:</p>
        <ul>
          <li>העתקה: העתקה של כל הרשימה.</li>
          <li>מחיקה: מחיקה של כל הרשימה. כדי למחוק מילה בודדת, יש ללחוץ על ה-X שמופיע לצד המילה בעת מעבר עכבר.</li>
          <li>הורדה: הורדה של כל הרשימה.</li>
        </ul>
        <h3>תבנית מילה</h3>
        <p>הכלי מאפשר למצוא מילים זהות לתבנית מילה מסוימת. את תבנית המילה אפשר להרכיב באמצעות בחירת אותיות וסימני ניקוד.</p>
        <p>בשביל להקל את העבודה, אפשר לעבור בין שדות הקלט של האותיות ושל הניקוד עם חיצי המקלדת, וכן לבצע מחיקה עם מקש Backspace.</p>
        <p>
        <u>אות:</u>
         אפשר להזין אות כלשהי מתוך האל"ף-בי"ת. אם ברצונכם שכל אחת מאותיות האל"ף-בי"ת תוכל להופיע באחד הריבועים - יש לסמן (?) בריבוע המבוקש. לקבלת רצף אותיות כלשהו, ולא רק אות בודדת, יש לסמן (*).</p>
        <p>בלחיצה על חיפוש, שדות קלט ריקים יקבלו את הסימן (?) שמשמעו כל אות.</p>
        <p>        
        <u>אות שורשית:</u> 
        ברירת המחדל המסומנת היא שהאות יכולה להיות "שורשית" או "שאינה שורשית".</p>
        <p>אפשר להגדיר את האות בריבוע הנתון כ"אות שורשית", כלומר השייכת לאחת מאותיות השורש של המילה, או לחילופין שאינה משתייכת לאחת מאותיות השורש באמצעות "אות שאינה שורשית".</p>
        <p>
        <u>ניקוד:</u>
         בכל ריבוע נתון אפשר להזין סימן ניקוד יחיד, או מספר סימני ניקוד אפשריים באמצעות כפתורי הניקוד שנמצאים למטה. הכפתור "ללא" מורה על כך שאין ניקוד לריבוע הנתון. </p>
        <p>הכפתור "הכול" נותן את כל אפשרויות הניקוד הקיימות בריבוע הנתון. כמו כן, אפשר לבחור צליל כללי, כגון A או E, כדי לכלול את כל סימני הניקוד שנהגים בצורה זהה.</p>
        <p>בלחיצה על חיפוש, שדות קלט ריקים יקבלו את המילה ״הכל״ שמשמעו כל סימני הניקוד.</p>
        <p>
        <u>דגש:</u>
        ברירת המחדל המסומנת היא שהאות יכולה להיות "עם דגש" או "ללא דגש", ללא חשיבות.</p>
        <p>אם ברצונכם שריבוע מסוים יהיה דגוש - יש לסמן "עם דגש", ולחילופין "ללא דגש" אם האות אינה דגושה.</p>
        <p>
        <u>ייבוא מילה:</u>
         אפשרות זו משמשת לייבוא מילה מתוך רשימה. המילה הנבחרת תוזן אוטומטית בשדות הקלט של "אות" ושל "ניקוד". בשדות הקלט של "אות" תופענה רק אותיות ניקוד (אהו"י), יתר אותיות האל"ף-בי"ת יוחלפו בסימן (?) שמאפשר לכלול כל אות. אפשר לערוך את התבנית לאחר ייבוא הטקסט.</p>
      </div>
    </div>
    <div v-else class="how-to-text px-3">
    </div>
  </b-modal>
</template>
<script>
export default {
  name: "about-dialog",
  props: ["value"],
  computed: {
    hebrew () {
      return this.$settings.hebrew
    },
    mobile () {
      return this.$mq === 'xs'
    },    
    show: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      }
    }
  }
};
</script>
<style lang="scss">
  @media screen and (max-width: 991px) {
    #how-modal{
      //-webkit-overflow-scrolling: touch;
      .modal-dialog {
        margin: 0!important;
      }
      .modal-content {
        border-radius: 0!important;
        height: 100vh;
        overflow-y: scroll;
        overflow-x:hidden;
        background:white;
      }
      .mobile-modal-top{
        height: 50px;
        top:0;
        right:0;
        padding:15px;
        z-index: 1;
        h3{text-decoration:none;}
      }
      .how-to-text{
        padding-top:50px;
        //max-height: 88vh;
        overflow-y: scroll;
        overflow-x:hidden;        
      }    
    }
  }
</style>
<style scoped lang="scss">
@media screen and (min-width: 992px) {
  .how-to-text {
    max-height: 70vh;
    overflow: auto;
    h3{
      text-decoration: underline;
    }
  }
}
</style>
